const questionsTypes = {
  audio: {
    request: "QUESTION_AUDIO_REQUEST",
    success: "QUESTION_AUDIO_SUCCESS",
    failure: "QUESTION_AUDIO_FAILURE"
  },

  duplicate: {
    request: "DUPLICATE_QUESTION_REQUEST",
    success: "DUPLICATE_QUESTION_SUCCESS",
    failure: "DUPLICATE_QUESTION_FAILURE",
    single:  "DUPLICATE_SINGLE_QUESTION_SUCCESS"
  },

  get: {
    request: "GET_QUESTION_REQUEST",
    success: "GET_QUESTION_SUCCESS",
    failure: "GET_QUESTION_FAILURE"
  },

  image: {
    request: "QUESTION_IMAGE_REQUEST",
    success: "QUESTION_IMAGE_SUCCESS",
    failure: "QUESTION_IMAGE_FAILURE"
  },

  index: {
    request: "QUESTIONS_INDEX_REQUEST",
    success: "QUESTIONS_INDEX_SUCCESS",
    failure: "QUESTIONS_INDEX_FAILURE"
  },

  version_media: {
    request: "VERSION_MEDIA_REQUEST",
    success: "VERSION_MEDIA_SUCCESS",
    failure: "VERSION_MEDIA_FAILURE"
  },

  csv: {
    request: "QUESTIONS_CSV_REQUEST",
    success: "QUESTIONS_CSV_SUCCESS",
    failure: "QUESTIONS_CSV_FAILURE"
  },

  create: {
    init:    "CREATE_QUESTION_INIT",
    request: "CREATE_QUESTION_REQUEST",
    success: "CREATE_QUESTION_SUCCESS",
    failure: "CREATE_QUESTION_FAILURE"
  },

  update: {
    request: "UPDATE_QUESTION_REQUEST",
    success: "UPDATE_QUESTION_SUCCESS",
    failure: "UPDATE_QUESTION_FAILURE"
  },

  upload_audio: {
    request: "UPLOAD_AUDIO_REQUEST",
    success: "UPLOAD_AUDIO_SUCCESS",
    failure: "UPLOAD_AUDIO_FAILURE",
  },

  upload_image: {
    request: "UPLOAD_IMAGE_REQUEST",
    success: "UPLOAD_IMAGE_SUCCESS",
    failure: "UPLOAD_IMAGE_FAILURE",
  },

  publish: {
    request: "PUBLISH_QUESTION_REQUEST",
    success: "PUBLISH_QUESTION_SUCCESS",
    failure: "PUBLISH_QUESTION_FAILURE",
    single:  "PUBLISH_SINGLE_QUESTION_SUCCESS"
  },
  //
  // unpublish: {
  //   request: "UNPUBLISH_QUESTION_REQUEST",
  //   success: "UNPUBLISH_QUESTION_SUCCESS",
  //   failure: "UNPUBLISH_QUESTION_FAILURE",
  //   single:  "UNPUBLISH_SINGLE_QUESTION_SUCCESS"
  // },

  destroy: {
    request: "DESTROY_QUESTION_REQUEST",
    success: "DESTROY_QUESTION_SUCCESS",
    failure: "DESTROY_QUESTION_FAILURE"
  },

  set_errors: "SET_QUESTION_ERRORS",

  // set_sorting: "SET_QUESTION_SORTING",
  //
  // set_filters: "SET_QUESTION_FILTERS",

  reset_question: "RESET_QUESTION",

  clear_question: "CLEAR_QUESTION",

}

export default questionsTypes



// WEBPACK FOOTER //
// ./src/js/constants/questionsTypes.js